/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Area_MinInputs */

const cs_requirements_area_min = /** @type {(inputs: Requirements_Area_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha od (m²)`)
};

const en_requirements_area_min = /** @type {(inputs: Requirements_Area_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area min (m²)`)
};

/**
* | output |
* | --- |
* | "Area min (m²)" |
*
* @param {Requirements_Area_MinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area_min = /** @type {((inputs?: Requirements_Area_MinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Area_MinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area_min(inputs)
	return cs_requirements_area_min(inputs)
});